import getConfig from "next/config";
import Link from "next/link";
import Button from "@components/Button";
import Heading from "@components/Heading";
import _get from "lodash/get";
import _has from "lodash/has";

const {
  publicRuntimeConfig: { settings },
} = getConfig();

const PromoCategory = ({ page, campaign, category }) => (
  <>
    {page.levels[2].active && (
      <>
        <ul className="flex flex-wrap -mx-1 md:-mx-2">
          {page.levels[2].subcategories.map((subcategory) => (
            <li
              key={subcategory.id}
              className="w-1/2 md:w-1/3 lg:w-1/4 p-1 md:p-2"
            >
              <Link
                href={`${settings.baseUrl}/promo/${campaign.slug}/${page.levels[1].slug}/${page.levels[2].slug}/${subcategory.slug}/`}
              >
                <a
                  className={`border-gray-1100 bg-white border   rounded-tr-lg rounded-bl-lg flex flex-col h-full p-4 text-center hover:shadow-mixRedYellow ${
                    _get(subcategory, "properties.icon_image", "")
                      ? "min-h-260px lg:min-h-320px"
                      : ""
                  }`}
                >
                  {_get(subcategory, "properties.icon_image", "") && (
                    <img
                      src={`${settings.cdn}${subcategory.properties.icon_image}`}
                      className="flex-none w-90px h-90px md:w-120px md:h-120px mx-auto mt-10"
                      alt=""
                    />
                  )}

                  <Heading
                    as="h2"
                    display="h4"
                    title={subcategory.name}
                    classesProp={`text-18px leading-22 -tracking-0.36 md:text-2xl md:leading-28.6 md:-tracking-0.48 text-black ${
                      _get(subcategory, "properties.icon_image", "")
                        ? "mt-5 md:mt-8"
                        : ""
                    }`}
                  />
                </a>
              </Link>
            </li>
          ))}
        </ul>
        <div className="mt-5 text-center">
          <div className="text-lg mb-6 text-black group-with-promoDarkTheme:text-white">
            Vezi toate produsele din categoria {category.name}
          </div>

          <div className="flex justify-center mt-10 w-full">
            <div className="w-full max-w-[260px]">
              <Button
                title={`Vezi ${page.levels[2].subcategories.reduce(
                  (total, elem) =>
                    _has(elem, "product_count")
                      ? total + elem.product_count
                      : total,
                  0
                )} produse`}
                display="block"
                size="normal"
                variant="primary"
                href={`${settings.baseUrl}/promo/${campaign.slug}/${page.levels[1].slug}/${page.levels[2].slug}/toate-produsele/`}
              />
            </div>
          </div>
        </div>
      </>
    )}

    {!page.levels[2].active && page.levels[1].active && (
      <>
        <ul className="flex flex-wrap -mx-1 md:-mx-2">
          {page.levels[1].subcategories.map((subcategory) => (
            <li
              key={subcategory.id}
              className="w-1/2 md:w-1/3 lg:w-1/4 p-1 md:p-2"
            >
              <Link
                href={`${settings.baseUrl}/promo/${campaign.slug}/${page.levels[1].slug}/${subcategory.slug}/`}
              >
                <a
                  className={`border-gray-1100 bg-white border   rounded-tr-lg rounded-bl-lg block p-4 text-center hover:shadow-mixRedYellow ${
                    _get(subcategory, "properties.icon_image", "")
                      ? "min-h-260px lg:min-h-320px"
                      : ""
                  }`}
                >
                  {_get(subcategory, "properties.icon_image", "") && (
                    <img
                      src={`${settings.cdn}${subcategory.properties.icon_image}`}
                      className="flex-none w-90px h-90px md:w-120px md:h-120px mx-auto mt-10"
                      alt=""
                    />
                  )}

                  <Heading
                    as="h2"
                    display="h4"
                    title={subcategory.name}
                    classesProp={`text-18px leading-22 -tracking-0.36 md:text-2xl md:leading-28.6 md:-tracking-0.48 text-black ${
                      _get(subcategory, "properties.icon_image", "")
                        ? "mt-5 md:mt-8"
                        : ""
                    }`}
                  />
                </a>
              </Link>

              {subcategory.subcategories &&
                subcategory.subcategories.length !== 0 && (
                  <ul className="p-0 px-3 mt-2">
                    {subcategory.subcategories.map((subSubCategory) => (
                      <li key={subSubCategory.id}>
                        <Link
                          href={`${settings.baseUrl}/promo/${campaign.slug}/${page.levels[1].slug}/${subcategory.slug}/${subSubCategory.slug}/`}
                        >
                          <a
                            className="py-1 block text-sm underline text-black hover:text-red-brand group-with-promoDarkTheme:text-gray-light"
                            title=""
                          >
                            {subSubCategory.name}
                          </a>
                        </Link>
                      </li>
                    ))}
                  </ul>
                )}
            </li>
          ))}
        </ul>

        <div className="mt-5 text-center">
          <div className="text-lg mb-6 text-black group-with-promoDarkTheme:text-white">
            Vezi toate produsele din categoria {category.name}
          </div>

          <div className="flex justify-center mt-10 w-full">
            <div className="w-full max-w-[260px]">
              <Button
                title={`Vezi ${page.levels[1].subcategories.reduce(
                  (total, lvl1) => {
                    if (lvl1.subcategories) {
                      return (
                        total +
                        lvl1.subcategories.reduce(
                          (totalChild, elem) =>
                            _has(elem, "product_count")
                              ? totalChild + elem.product_count
                              : totalChild,
                          0
                        )
                      );
                    } else if (_has(lvl1, "product_count")) {
                      return total + lvl1.product_count;
                    } else {
                      return total;
                    }
                  },
                  0
                )} produse`}
                display="block"
                size="normal"
                variant="primary"
                href={`${settings.baseUrl}/promo/${campaign.slug}/${page.levels[1].slug}/toate-produsele/`}
              />
            </div>
          </div>
        </div>
      </>
    )}
  </>
);

export default PromoCategory;
